<template>
   <Users></Users>
</template>
<script>
import Users from '@/components//DPEBB/Administrator/Users.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID :6, 
        }
    },
 components: {
    Users  : Users 
        },
   created: function() {
        this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() { 
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
   
    },
}
</script>
